import React from 'react';
import { Box } from '@chakra-ui/react';

const SuspenseLoader = ({ loadingText = `Loading...` }) => {
  return <Box w="100%">{loadingText}</Box>;
};

export default SuspenseLoader;
